import axios from "axios";

export default () => {
  return axios.create({
    baseURL: process.env.VUE_APP_WINDU_BACK,
    withCredentials: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    }
  });
};
